import { render, staticRenderFns } from "./detailSon.vue?vue&type=template&id=0cc6cdca&scoped=true"
import script from "./detailSon.vue?vue&type=script&lang=js"
export * from "./detailSon.vue?vue&type=script&lang=js"
import style0 from "./detailSon.vue?vue&type=style&index=0&id=0cc6cdca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc6cdca",
  null
  
)

export default component.exports